import React, { useEffect } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import axios from "../../../utils/http";
import { SEND_OTP, VERIFY_OTP } from "../../../utils/urls";
import { useHistory } from "react-router";

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { getAuthToken } from '../../../utils/localStorage';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
// import FormControl from '@mui/material/FormControl';
import Select from "@mui/material/Select";

import { ArrowBackIos, MoreVert } from "@material-ui/icons";
// import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import "./style.css";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "90vh",
        padding: "20px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "10px",
      },
    },
    typography: {
      color: "#414141",
      fontSize: "20px",
    },
    fab: {
      backgroundColor: "#DA222C",
      width: "220px",
      borderRadius: "25px",
      textDecoration: "underline",
    },
    countDownTimmer: {
      // backgroundColor: "#DA222C",
      justifyContent: "center",
      width: "50px",
      borderRadius: "10px",
      textDecoration: "underline",
    },
  })
);

export default function Registration() {
  const history = useHistory();
  const classes = useStyles();
  const [seconds, setSeconds] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState({
    status: false,
    results: "",
  });
  const [crn, setCRNData] = React.useState({});
  const [otpView, setOtpView] = React.useState(false);
  const [mobileNo, setMobileNo] = React.useState("");
  const [error, setError] = React.useState("");
  const [otp1, setOtp1] = React.useState("");
  const [otp2, setOtp2] = React.useState("");
  const [otp3, setOtp3] = React.useState("");
  const [otp4, setOtp4] = React.useState("");
  const [loader, setLoader] = React.useState(false);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  }, [seconds]);

  const handleClickShowMobile = () => {};
  const handleMouseDownMobile = () => {};
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type?: string
  ) => {
    if (e.target.value == "") {
      setOtpView(false);
      return;
    }
    if (type === "otp1") {
      setOtp1(e.target.value);
      let x = window.document.getElementById("second")!;
      x.focus();
    }
    if (type === "otp2") {
      setOtp2(e.target.value);
      let x = window.document.getElementById("third")!;
      x.focus();
    }
    if (type === "otp3") {
      setOtp3(e.target.value);
      let x = window.document.getElementById("fourth")!;
      x.focus();
    }
    if (type === "otp4") {
      setOtp4(e.target.value);
      let x = window.document.getElementById("fourth")!;
      x.blur();
    } else {
      setError("");
    }
  };

  const sendOtp = () => {
    if (mobileNo == "" || mobileNo.length !== 10) {
      return setError("Plese enter valid mobile number");
    }
    setLoading(true);
    setError("");
    const data = { phone: mobileNo };

    setLoader(true);
    setSeconds(0);
    axios
      .post(SEND_OTP, data)
      .then((response) => {
        if (response.status) {
          setOtpView(true);
          setLoading(false);
          setSeconds(30);
          setData({
            status: true,
            results: "OTP send successfully.",
          });
          setLoader(false);
        } else {
          setError("");
        }
      })
      .catch((error) => {
        setOtpView(false);
        setError(error.response.data.errors);
        setLoader(false);
        setLoading(false);
        console.error(error);
      });
  };

  const verifyOtp = () => {
    const otp = otp1 + otp2 + otp3 + otp4;
    if (otp == "" || otp.length < 4) {
      return setError("Please enter a valid otp");
    }
    setError("");
    const data = {
      phone: mobileNo,
      otp: otp,
    };

    setLoader(true);
    axios
      .post(VERIFY_OTP, data)
      .then((response) => {
        let x: any = JSON.parse(JSON.stringify(response));
        if (response.status) {
          setLoader(false);
          setCRNData(response);
          history.push("/product-details", {
            crn: x.data.results.crn,
            application_id: x.data.results.cd_application_id,
          });
        } else {
          setError("");
        }
      })
      .catch(function (error) {
        console.error(error);
        setLoader(false);
      });
  };

  const resendOtp = () => {
    setLoading(true);
    const data = { phone: mobileNo };
    axios
      .post(SEND_OTP, data)
      .then((response) => {
        if (response?.status) {
          setLoading(false);
          setSeconds(20);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(error.response.data.errors);
      });
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <div>
      <div>
        <Header pageName="Registration" />
      </div>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Box className="registrationBox newCard" component="div">
              <h3 className="enterRM">
                Enter the registered Mobile/ CR Number
              </h3>

              {/* <Box component="div" mt={3} style={{ marginTop: "80px" }}>
                 <Button onClick={()=>history.goBack()} style={{margin:"-20px"}}>
                <ArrowBackIos fontSize="small" />
              </Button> */}

              {/* <Typography variant="h6" display="inline">
                Back
              </Typography> 
              <div style={{marginLeft:"255px",marginTop:"-32px"}}>
                <Logout/>
              </div> 
              </Box>*/}

              <Box component="div" mt={3} style={{ marginTop: "80px" }}>
                {error ? (
                  <Box sx={{ mb: 3 }}>
                    <h6 className="errorMsg">{error}</h6>
                  </Box>
                ) : (
                  ""
                )}
                <Box sx={{ mb: 1, fontSize: 18, color: "#131313", ml: 2 }}>
                  <span>Mobile Number</span>
                </Box>
                <FormControl
                  className="mobileNoField"
                  fullWidth
                  variant="outlined"
                >
                  <OutlinedInput
                    id="outlined-adornment-mobile"
                    type="text"
                    defaultValue={mobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle mobile visibility"
                          onClick={handleClickShowMobile}
                          onMouseDown={handleMouseDownMobile}
                          edge="end"
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={120}
                  />
                </FormControl>
              </Box>
              {otpView && (
                <Box component="div" mt={5} textAlign="center" sx={{ mt: 10 }}>
                  <div className="mb-6">
                    <div>Enter OTP</div>
                    <div id="otp" className="flex justify-center enterOTP">
                      <input
                        className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                        type="text"
                        id="first"
                        onChange={(e) => handleChange(e, "otp1")}
                        maxLength={1}
                      />
                      <input
                        className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                        type="text"
                        id="second"
                        onChange={(e) => handleChange(e, "otp2")}
                        maxLength={1}
                      />
                      <input
                        className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                        type="text"
                        id="third"
                        onChange={(e) => handleChange(e, "otp3")}
                        maxLength={1}
                      />
                      <input
                        className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                        type="text"
                        id="fourth"
                        onChange={(e) => handleChange(e, "otp4")}
                        maxLength={1}
                      />
                    </div>
                    {seconds === 0 ? (
                      <>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ marginTop: "120px" }}
                          className="redButton"
                          onClick={sendOtp}
                          disabled={false}
                        >
                          {loading && <CircularProgress color="secondary" />}
                          Resend Otp
                        </Button>
                      </>
                    ) : (
                      <div className="mb-6">
                        <h3>{seconds}</h3>
                      </div>
                    )}
                  </div>
                </Box>
              )}

              <Box textAlign="center" sx={{ mt: 15 }}>
                {otpView ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ marginTop: "0px" }}
                    className="redButton"
                    onClick={verifyOtp}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    className="redButton"
                    onClick={sendOtp}
                  >
                    {loading && <CircularProgress color="primary" />}
                    Send OTP
                  </Button>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
